import clsx from 'clsx';
import { GridItem, GridRow } from '../../Grid';
import NextImage from '../../NextImage';
import type { Seal } from '../types';
import type { ReactNode } from 'react';

interface ISeals {
  seals: Seal[];
  textColorToken?: string;
}

interface ISealWrapper {
  isCustomSize: boolean;
  children: ReactNode;
}

const SealWrapper = ({ isCustomSize, children }: ISealWrapper) => {
  return isCustomSize ? (
    <div>{children}</div>
  ) : (
    <GridRow columns={16}>
      <GridItem colSpan={16}>{children}</GridItem>
    </GridRow>
  );
};

const Seals = ({ seals, textColorToken }: ISeals) => {
  const isCustomSize = seals.some((seal) => !!seal.sealWidth);

  return (
    <SealWrapper isCustomSize={isCustomSize}>
      <div
        className={clsx(
          'border-t md:pt-20 md:mt-20 sm:pt-10 sm:mt-5 w-full md:w-auto flex flex-wrap md:flex-nowrap',
          {
            'border-cake': !textColorToken,
            'grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6': !isCustomSize,
          },
        )}
      >
        {seals.map((footerSeals: Seal) => (
          <div
            className="w-full flex items-center flex-col text-center justify-end"
            key={`seal-${footerSeals?.id}`}
          >
            <a
              href={footerSeals?.url}
              target="_blank"
              rel="noreferrer"
              className="flex flex-col items-center"
            >
              {footerSeals?.assetsComponents?.asset?.[0]?.url && (
                <NextImage
                  src={footerSeals?.assetsComponents?.asset?.[0]?.url}
                  mimeType={String(footerSeals?.assetsComponents?.asset?.[0]?.mimeType)}
                  height={footerSeals.sealHeight || 68}
                  width={footerSeals.sealWidth || 68}
                  className={clsx('mb-[12px]', { 'w-[68px] ': !isCustomSize })}
                  alt={`${footerSeals.name} logo`}
                />
              )}
              <span>{footerSeals.name}</span>
            </a>
          </div>
        ))}
      </div>
    </SealWrapper>
  );
};

export default Seals;
